import { flow } from 'lodash';
import _groupBy from 'lodash/fp/groupBy';
import _map from 'lodash/fp/map';
import _orderBy from 'lodash/fp/orderBy';
import getSemverMajor from 'semver/functions/major';
import getSemverMinor from 'semver/functions/minor';
import getSemverPatch from 'semver/functions/patch';
import isValidSemver from 'semver/functions/valid';

import { UI__ClientsPageQuery_service_stats_queryStats as QueryStatsType } from 'src/lib/graphqlTypes/types';

export const groupQueryStatsByClientVersion: (
  queryStats: QueryStatsType[],
) => Array<{
  clientVersion: string | null;
  groupedQueryStats: QueryStatsType[];
}> = flow([
  _groupBy((stats: QueryStatsType) => stats.groupBy.clientVersion),
  Object.entries,
  _orderBy(
    [
      ([clientVersion]) => (isValidSemver(clientVersion) ? 1 : 0),
      ([clientVersion]) =>
        isValidSemver(clientVersion) && getSemverMajor(clientVersion),
      ([clientVersion]) =>
        isValidSemver(clientVersion) && getSemverMinor(clientVersion),
      ([clientVersion]) =>
        isValidSemver(clientVersion) && getSemverPatch(clientVersion),
    ],
    ['desc', 'desc', 'desc', 'desc'],
  ),
  _map(([, groupedQueryStats]: [string, QueryStatsType[]]) => ({
    // don't use the grouped-on key because it could contain 'null'
    clientVersion: groupedQueryStats[0]?.groupBy.clientVersion,
    groupedQueryStats,
  })),
]);
